const LoadingSpinner = () => (
  <div className="lds-facebook loading"><div></div><div></div><div></div></div>
);

export default LoadingSpinner;